import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema} from '/vercel/path0/frontend/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/frontend/markdoc/tags.js'
import * as nodes from '/vercel/path0/frontend/markdoc/nodes.js'
const functions = {};
const schema = {
tags: tags ? (tags.default || tags) : {},
nodes: nodes ? (nodes.default || nodes) : {},
functions: functions ? (functions.default || functions) : {},
...(config ? (config.default || config) : {}),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "\n## Pojęcia\n\nAutorski system i miłość do języka polskiego powoduje, że czasami należy uciec do neologizmów a niektóre wyrazy są po prostu trudne.\n\n### Kod QR\n\nKod zawierający w sobie informację, która może być odczytana za pomocą kompatybilnych czytników (kamery, smartfonu z kamerą, skanera)\n\n### Bibliodesk\n\nGłówna baza dowodzenia naszym księgozbiorem. Panel, który dostępny jest dla zalogowanych użytkowników.\n\n### Generator Kodów\n\nMówiąc prosto - przycisk. Ten przycisk uruchamia lawinę procesów, więc można powiedzieć, że generatorem kodów jest proces obliczeniowy na serwerze (innym komputerze), który zwraca nam informację w postaci pliku PDF z kodami. Klikamy generuj i zapisujemy PDF.\n\n### BGS\n\nBarcode General Scanner czyli kreator, który przeprowadza nas przez proces dodawania informacji o książce do kodu QR. Nazwa powstała od Bee Gees - znanego zespołu lat 80-tych.";
const filepath = "/docs/slownik-pojec.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
